package com.arena_web.domain.usecases.auth

import com.arena_web.domain.repositories.UserRepository
import com.arena_web.utils.Storage

class DeleteAccountUseCase(private val userRepository: UserRepository) {

    suspend operator fun invoke(): Result<Unit> {
        val result = userRepository.deleteMe()
        if (result.isSuccess) {
            Storage.clearSession()
        }
        return result
    }
}
